import { isSameDay } from 'date-fns';
import { type Event, getCurrentUserRole, getCurrentUserRsvp } from 'models';
import { WidgetItem } from 'ui';
import { useUser } from 'features/auth';
import { EventActions, useIsLiveStatus } from 'features/events';

type P = {
  getPathToEventDetail: (id: string) => string;
  invitation: Event;
};

const NodeInvitationWidgetItem = ({ getPathToEventDetail, invitation }: P) => {
  const { nodeUserData: nodeViewer } = useUser();
  const { endTime, id, name, participants, startTime, status } = invitation;
  const isLive = useIsLiveStatus({ endTime, startTime, status });
  const currentUserRsvp = getCurrentUserRsvp({ participants, viewerId: nodeViewer._id });
  const currentUserRole = getCurrentUserRole({ participants, viewerId: nodeViewer._id });

  const event = {
    endTime,
    id,
    role: currentUserRole,
    rsvp: currentUserRsvp,
    startTime,
    status: 'active' as const,
  };

  const timeConfig = {
    options: {
      display: isSameDay(startTime, new Date()) ? ('time' as const) : ('full' as const),
      mode: 'default' as const,
    },
    time: startTime,
  };

  return (
    <WidgetItem
      activeDate={new Date()}
      description={name}
      item={<EventActions event={event} />}
      path={getPathToEventDetail(id)}
      tags={isLive ? ['live'] : undefined}
      timeConfig={timeConfig}
    />
  );
};

export default NodeInvitationWidgetItem;
